import { parseArrowSync } from "./parsers/parse-arrow-sync.js";
import { parseArrowInBatches } from "./parsers/parse-arrow-in-batches.js";
const VERSION = typeof "4.1.0-alpha.9" !== 'undefined' ? "4.1.0-alpha.9" : 'latest';
export const ArrowWorkerLoader = {
  name: 'Apache Arrow',
  id: 'arrow',
  module: 'arrow',
  version: VERSION,
  category: 'table',
  extensions: ['arrow', 'feather'],
  mimeTypes: ['application/vnd.apache.arrow.file', 'application/vnd.apache.arrow.stream', 'application/octet-stream'],
  binary: true,
  tests: ['ARROW'],
  options: {
    arrow: {
      shape: 'columnar-table'
    }
  }
};
export const ArrowLoader = {
  ...ArrowWorkerLoader,
  parse: async (arraybuffer, options) => parseArrowSync(arraybuffer, options === null || options === void 0 ? void 0 : options.arrow),
  parseSync: (arraybuffer, options) => parseArrowSync(arraybuffer, options === null || options === void 0 ? void 0 : options.arrow),
  parseInBatches: parseArrowInBatches
};
//# sourceMappingURL=arrow-loader.js.map